import { Component, Input } from '@angular/core';
import { NgxPopupComponent } from '@components/shared/ngx-popups/ngx-popups/components/popup.component';
import { SpreadingTemplateService } from '@services/spreading-template.service';

@Component({
  selector: 'app-edit-partner-api-alias',
  templateUrl: './edit-partner-api-alias.component.html',
  styleUrls: ['./edit-partner-api-alias.component.scss'],
  standalone: false
})
export class EditPartnerApiAliasComponent {
  @Input() popup: NgxPopupComponent;
  @Input() templateId: number;
  @Input() templateName: string;

  @Input()
  set clientAlias(value: string | null) {
    this.inputValue = value || '';
    this.errorMessage = '';
  }

  title = 'Edit Partner API Alias';
  inputLabel = 'Partner API Alias (client_alias)';
  inputPlaceholder = 'e.g. GEN_CORP';
  helperText = 'Value Citi’s batch submissions send as spreading_template_client_alias to resolve to this template. '
    + 'Matching is case-insensitive and ignores leading/trailing spaces.';

  fallbackErrorMessage = 'Unable to save the alias. Please try again.';

  inputValue = '';
  errorMessage = '';
  submitted = false;

  constructor(private _spreadingTemplateService: SpreadingTemplateService) {}

  get isSaveDisabled(): boolean {
    return this.submitted || !!this.errorMessage;
  }

  onInputChange(value: string): void {
    this.inputValue = value;
    this.errorMessage = '';
  }

  onClear(): void {
    this.inputValue = '';
    this.errorMessage = '';
  }

  onConfirm(): void {
    this.submitted = true;
    const trimmedAlias = this.inputValue.trim();
    const clientAlias = trimmedAlias === '' ? null : trimmedAlias;

    this._spreadingTemplateService.updateClientAlias(this.templateId, clientAlias).subscribe(
      result => {
        this.submitted = false;
        this.errorMessage = '';
        this.popup.close(true, {
          confirmed: true,
          clientAlias: result?.[0]?.clientAlias ?? null
        });
      },
      error => {
        this.errorMessage = error?.message || this.fallbackErrorMessage;
        this.submitted = false;
      }
    );
  }

  onCancel(): void {
    this.popup.close(true);
  }
}
